import { render, staticRenderFns } from "./SistemasIntegracao.vue?vue&type=template&id=45303381"
import script from "./SistemasIntegracao.vue?vue&type=script&lang=js"
export * from "./SistemasIntegracao.vue?vue&type=script&lang=js"
import style0 from "./SistemasIntegracao.vue?vue&type=style&index=0&id=45303381&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports